/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plan: NonNullable<unknown> }} Activeeventslimitreached3Inputs */

const en_activeeventslimitreached3 = /** @type {(inputs: Activeeventslimitreached3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have reached the limit of ${i?.count} active events on the ${i?.plan} plan.`)
};

const de_activeeventslimitreached3 = /** @type {(inputs: Activeeventslimitreached3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast das Limit von ${i?.count} aktiven Events im ${i?.plan}-Plan erreicht.`)
};

/**
* | output |
* | --- |
* | "You have reached the limit of {count} active events on the {plan} plan." |
*
* @param {Activeeventslimitreached3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const activeeventslimitreached3 = /** @type {((inputs: Activeeventslimitreached3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activeeventslimitreached3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activeeventslimitreached3(inputs)
	return de_activeeventslimitreached3(inputs)
});
export { activeeventslimitreached3 as "activeEventsLimitReached" }